import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { IAddon } from "@bca-shared/models/addon";

@Component({
  selector: "bca-product-addon",
  templateUrl: "product-addon.component.html",
  styleUrls: ["product-addon.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductAddonComponent {
  @ViewChild("buttonRefTrue") buttonRefTrue: ElementRef;
  @ViewChild("buttonRefFalse") buttonRefFalse: ElementRef;
  @Input()
  addon: IAddon;
  @Input()
  routeLoading: boolean;
  @Output()
  selected = new EventEmitter<boolean>();
}
